module.exports = __webpack_public_path__ + "img/12_64.4a76704a.png";